/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { ComponentTypeBadge } from '../../../AllComponents/elements/ComponentTypeBadge/ComponentTypeBadge';
import { ComponentDetailsProps } from '../../ComponentDetails.props';

/**
 * Component details description.
 * @param {ComponentDetailsProps} props Component details props.
 * @export
 * @returns {JSX.Element} The `<ComponentDetailsDescription />` component.
 */
export const ComponentDetailsDescription = (props: ComponentDetailsProps): JSX.Element => {
  const { componentDetails, namespace, name, componentType } = props;
  return (
    <div className="component-details">
      <div className="component-details__description">
        <span className="component-details__description-sub-heading-id">ID: </span>
        <span className="component-details__description-sub-heading">{`${namespace}/${name}`}</span>
        <div className="component-details__description-footer">
          <ComponentTypeBadge componentType={componentType} />
        </div>
        <span className="component-details__description-content">{componentDetails.description}</span>
      </div>
    </div>
  );
};
